import { render, staticRenderFns } from "./needPc.vue?vue&type=template&id=0b6bce3a&"
import script from "./needPc.vue?vue&type=script&lang=js&"
export * from "./needPc.vue?vue&type=script&lang=js&"
import style0 from "./needPc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports